/* unplugin-vue-components disabled */import script from "./TaxYear.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxYear.vue?vue&type=script&setup=true&lang=js"

import "./TaxYear.vue?vue&type=style&index=0&id=54f4ed72&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f4ed72"]])

export default __exports__